import { ArrowLeftOutlined, CheckOutlined } from '@ant-design/icons';
import {
  AutoComplete,
  Button,
  Card,
  Checkbox,
  Col,
  Empty,
  Image,
  PageHeader,
  Row,
  Skeleton,
  Tag,
  Typography,
  notification,
} from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import default_bank from '../../../../Assets/ic_default_bank.png';
import FIPModel, { requiredIdentifier } from '../../../../Models/FIPModel';
import { GetFIPRequest } from '../../../../Models/Request/FIP/GetAllFIP';
import { AddIdentifier } from '../../../../Models/Request/Identifier/AddIdentifier';
import AccountLinkConfirmationResponse, {
  AccountLinkConfirmation,
} from '../../../../Models/Response/Account/AccountLink';
import DiscoverAccountResponse from '../../../../Models/Response/Account/DiscoverAccount';
import {
  discoverAccounts,
  linkAccountVerification,
  linkAccounts,
} from '../../../../Services/AccountsServices/AccountService';
import { getFips } from '../../../../Services/FipServices/FipServices';
import { logoBaseUrl } from '../../../../Utils/Constants/baseUrl';
import { QueryParams, Routes } from '../../../../Utils/Constants/routes';
import OTPInputComponent from '../../../Common/Components/OTPModal';
import Identifiers from '../../../Identifiers';
import './index.css';

const LinkAccounts: React.FC = () => {
  const [discoverAccountsList, storeDiscoverAccounts] = useState<any[]>([]);

  const [fipListToBeShown, setFipListToBeShown] = useState(
    new Array<FIPModel>()
  );
  const loading: boolean = useSelector(
    (state: any) => state.loader.searchLoader
  );
  const [currentFip, setCurrentFip] = useState({
    id: '',
    name: '',
    host: '',
    version: '',
    Identifiers: new Array<requiredIdentifier>(),
  });
  const [selectedAccounts, setSelectedAccounts] = useState(new Array<string>());
  const [isOTPModalVisible, setIsOTPModalVisible] = useState(false);
  const [identifiers, setIdentifiers] = useState(new Array<AddIdentifier>());
  const [signature, setSignature] = useState('');
  const [refNumber, setRefNumber] = useState('');
  const [step, setStep] = useState(0);
  const { t } = useTranslation();
  const history = useHistory();
  const [fip, storeFIP] = useState<GetFIPRequest>([]);

  const useQuery = () => {
    const { search } = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
  };
  const query: any = useQuery();

  useEffect(() => {
    setFipListToBeShown(fip);
  }, [fip]);

  useEffect(() => {
    getFips()
      .then((res) => res.data)
      .then((res: GetFIPRequest) => storeFIP(res));
  }, [storeFIP]);

  const onFIPSelect = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    setCurrentFip(fipListToBeShown[parseInt(event.currentTarget.id, 10)]);
  };

  const onAccountsSelect = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    if (selectedAccounts.includes(event.currentTarget.id)) {
      setSelectedAccounts(
        selectedAccounts.filter((item) => item !== event.currentTarget.id)
      );
    } else {
      const accounts = [...selectedAccounts];
      accounts.push(event.currentTarget.id);
      setSelectedAccounts(accounts);
    }
  };

  const linkAccount = () => {
    linkAccounts({
      FipId: currentFip.id,
      Accounts: discoverAccountsList.filter(
        (_account, index) =>
          selectedAccounts.filter((value) => value === index.toString())[0]
      ),
      signature,
    })
      .then((res) => res.data)
      .then((_res: AccountLinkConfirmationResponse) => {
        setIsOTPModalVisible(true);
        setRefNumber(_res.refNumber);
      });
  };

  const onLinkAccountOtp = (otp: string) => {
    linkAccountVerification(refNumber, otp, currentFip.id)
      .then((res) => res.data)
      .then((_res: AccountLinkConfirmation) => {
        notification.success({
          message: t('Account linked successfully'),
        });
        setIsOTPModalVisible(false);
        setSelectedAccounts([]);
        setCurrentFip({
          id: '',
          name: '',
          host: '',
          version: '',
          Identifiers: new Array<requiredIdentifier>(),
        });

        if (query && query.get(QueryParams.redirect)) {
          history.push(query.get(QueryParams.redirect));
        } else {
          history.push(Routes.account);
        }
      });
  };

  const onCancel = () => {
    setIsOTPModalVisible(false);
  };

  const discoverAccountWithIdentifiers = () => {
    discoverAccounts({
      FITypes: [''],
      FipId: currentFip.id,
      Identifiers: identifiers,
    })
      .then((res) => res.data)
      .then((res: DiscoverAccountResponse) => {
        storeDiscoverAccounts(res.DiscoveredAccounts);
        setSignature(res.signature);
      })
      .catch(() => storeDiscoverAccounts([]));
    setStep(step + 1);
  };

  const selectFIP = () => {
    setStep(step + 1);
    setFipListToBeShown(fip);
  };

  const onSearchValueChange = (value: string) => {
    setFipListToBeShown(
      value
        ? fip.filter(
            (p) => p.name.toUpperCase().indexOf(value.toUpperCase()) !== -1
          )
        : fip
    );
  };

  const changeIndetifier = () => {
    setStep(step - 1);
    setSelectedAccounts([]);
  };

  const goBack = () => {
    if (step === 2) {
      setStep(step - 1);
      setSelectedAccounts([]);
    } else {
      setStep(step - 1);
    }
  };

  const onRadioSelect = (e: any) => {
    setIdentifiers(e);
  };

  const memoizedCallback = useCallback(onRadioSelect, []);

  const renderStep = () => {
    if (step === 0) {
      return (
        <>
          <div className='fipCard'>
            <Row justify='space-between'>
              {loading ? (
                <>
                  <Col
                    style={{ marginTop: 10 }}
                    span={6}
                    xs={{ span: 24 }}
                    sm={{ span: 11 }}
                    md={{ span: 7 }}
                    lg={{ span: 7 }}
                  >
                    {' '}
                    <Skeleton />{' '}
                  </Col>
                  <Col
                    span={6}
                    style={{ marginTop: 10 }}
                    xs={{ span: 24 }}
                    sm={{ span: 11 }}
                    md={{ span: 7 }}
                    lg={{ span: 7 }}
                  >
                    {' '}
                    <Skeleton />{' '}
                  </Col>
                  <Col
                    style={{ marginTop: 10 }}
                    span={6}
                    xs={{ span: 24 }}
                    sm={{ span: 11 }}
                    md={{ span: 7 }}
                    lg={{ span: 7 }}
                  >
                    {' '}
                    <Skeleton />{' '}
                  </Col>
                  <Col
                    span={6}
                    style={{ marginTop: 10 }}
                    xs={{ span: 24 }}
                    sm={{ span: 11 }}
                    md={{ span: 7 }}
                    lg={{ span: 7 }}
                  >
                    {' '}
                    <Skeleton />{' '}
                  </Col>
                  <Col
                    span={6}
                    style={{ marginTop: 10 }}
                    xs={{ span: 24 }}
                    sm={{ span: 11 }}
                    md={{ span: 7 }}
                    lg={{ span: 7 }}
                  >
                    {' '}
                    <Skeleton />{' '}
                  </Col>
                  <Col
                    span={6}
                    style={{ marginTop: 10 }}
                    xs={{ span: 24 }}
                    sm={{ span: 11 }}
                    md={{ span: 7 }}
                    lg={{ span: 7 }}
                  >
                    {' '}
                    <Skeleton />{' '}
                  </Col>
                </>
              ) : (
                fipListToBeShown &&
                fipListToBeShown.map((FIP: FIPModel, index) => (
                  <Col
                    span={6}
                    xs={{ span: 24 }}
                    sm={{ span: 12 }}
                    md={{ span: 8 }}
                    lg={{ span: 8 }}
                  >
                    <Card
                      key={index}
                      className={`${
                        FIP.isEnabled ? 'enabled' : 'disabled'
                      }FIP accountCard`}
                      id={index.toString()}
                      hoverable={FIP.isEnabled ? true : false}
                      onClick={FIP.isEnabled ? onFIPSelect : undefined}
                    >
                      <Image
                        className='fipLogo'
                        src={logoBaseUrl + FIP.id + '.png'}
                        fallback={default_bank}
                        preview={false}
                      />

                      <div className='cardContent'>
                        <Typography.Text className='cardContentFIP'>
                          {FIP.name}
                        </Typography.Text>
                        <Typography.Text className='cardContentFIP requiresIdentifier'>
                          {FIP.Identifiers.length > 1
                            ? `Requires  ${FIP.Identifiers.map((identifier) => {
                                return identifier.type
                                  ? ' ' + identifier.type
                                  : ' MOBILE';
                              })}`
                            : ''}
                        </Typography.Text>
                      </div>
                      {FIP.isEnabled ? (
                        currentFip.id === FIP.id && (
                          <CheckOutlined className='checkOutlined checkBox' />
                        )
                      ) : (
                        <Tag>{t('Coming Soon')}</Tag>
                      )}
                    </Card>
                  </Col>
                ))
              )}
            </Row>
          </div>
          <Button
            disabled={currentFip.id.length === 0}
            id='fipSelect'
            className='primaryButton'
            onClick={selectFIP}
          >
            {t('Continue')}
          </Button>
        </>
      );
    }
    return step === 1 ? (
      <Identifiers
        onRadioSelect={memoizedCallback}
        onSelectIdentifier={discoverAccountWithIdentifiers}
        requiredIdentifier={currentFip.Identifiers}
      />
    ) : (
      <div className='linkAccountBody'>
        <div className='typoAccountDiscovery'>
          <Typography.Text>
            {t('Following information will be used to discover your')}{' '}
            <Typography.Text>{currentFip.name}</Typography.Text> {t('accounts')}
          </Typography.Text>
          <div className='typoIdentifierInformation'>
            <Typography.Text>
              {t('MOBILE NUMBER')}{' '}
              <Typography.Text>{identifiers[0].value}</Typography.Text>
            </Typography.Text>
            <Button
              className='changeIdentifier'
              type='text'
              onClick={changeIndetifier}
            >
              {t('change')}
            </Button>
          </div>
          <Typography.Text className='typoWarning'>
            {t('Ensure that the mobile number is linked to your account')}
          </Typography.Text>
        </div>
        <div className='discoverAccounts'>
          <Row>
            {discoverAccountsList && discoverAccountsList.length ? (
              discoverAccountsList.map((accounts, index) => (
                <Col
                  span={6}
                  xs={{ span: 24 }}
                  sm={{ span: 12 }}
                  md={{ span: 8 }}
                  lg={{ span: 8 }}
                >
                  <Card
                    key={index}
                    bodyStyle={{
                      backgroundColor: selectedAccounts.includes(
                        index.toString()
                      )
                        ? '#f5f5f5'
                        : 'transparent',
                    }}
                    className='accountCard'
                    id={index.toString()}
                    hoverable={true}
                    onClick={onAccountsSelect}
                  >
                    {
                      <Image
                        className='fipLogo'
                        src={logoBaseUrl + currentFip.id + '.png'}
                        fallback={default_bank}
                        preview={false}
                      />
                    }
                    <div className='cardContent'>
                      <Typography.Text className='cardContentFIP'>
                        {currentFip && currentFip.name}
                      </Typography.Text>
                      <Typography.Text className='cardContentMaskedNumber'>
                        {accounts.maskedAccNumber}
                      </Typography.Text>
                      <Typography.Text className='cardContentFIType'>
                        {accounts.FIType}
                      </Typography.Text>
                    </div>

                    <Checkbox
                      checked={selectedAccounts.includes(index.toString())}
                      className='checkBox'
                    />
                  </Card>
                </Col>
              ))
            ) : (
              <Empty
                style={{ margin: '10px auto' }}
                description={
                  <Typography.Text className='noAccountFound'>
                    {t('No Accounts Found')}
                  </Typography.Text>
                }
              />
            )}
          </Row>
        </div>
        <Button
          disabled={selectedAccounts.length ? false : true}
          id='loginButton'
          className='primaryButton linkAccountButton'
          onClick={linkAccount}
        >
          {t('LINK ACCOUNTS')}
        </Button>
      </div>
    );
  };

  return (
    <>
      <OTPInputComponent
        onCancel={onCancel}
        isOpen={isOTPModalVisible}
        onOtpSubmit={onLinkAccountOtp}
        okText={t('CONFIRM')}
        title={t('LINK ACCOUNTS')}
        onResend={linkAccount}
        mobileNumber={
          identifiers && identifiers.length !== 0 ? identifiers[0].value : ''
        }
        isLinkAccount={true}
      />
      <div className='linkAccountRoot'>
        <div className='linkAccountHeader'>
          <PageHeader
            className='linkAccountTitle'
            backIcon={
              step !== 0 ? <ArrowLeftOutlined className='backIcon' /> : <></>
            }
            onBack={goBack}
            title={t('LINK ACCOUNTS')}
            extra={
              step === 0 && (
                <AutoComplete
                  allowClear={true}
                  autoFocus={true}
                  open={false}
                  autoClearSearchValue={true}
                  style={{ width: 200 }}
                  placeholder={t('Which bank do you want to link? ')}
                  onChange={onSearchValueChange}
                />
              )
            }
          />
        </div>
        {renderStep()}
      </div>
    </>
  );
};

export default LinkAccounts;
